import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { Validators } from '@angular/forms';
import { UserDataService } from '../../../data-storage/user-data.service';
import { Input } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { Validator } from '@angular/forms';
import { ValidationErrors } from '@angular/forms';
import { AbstractControl } from '@angular/forms';
import { forwardRef } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PartnerAddressDto } from '../../../../../dtos/partnerAddressDto';
import { UserDto } from '../../../../../dtos/userDto';

@Component({
  selector: 'app-user-basic-info',
  templateUrl: './user-basic-info.component.html',
  styleUrls: ['./user-basic-info.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UserBasicInfoComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => UserBasicInfoComponent),
      multi: true
    }
  ]
})
export class UserBasicInfoComponent implements OnInit, ControlValueAccessor, Validator {

  constructor(private userDataService: UserDataService) { }

  @Input()
  readonlyOnValid:boolean;

  @Input()
  columns: number = 2;

  readonlyState:any;
  public userForm: FormGroup;
  private currentUser: UserDto;

  ngOnInit(): void {
    this.currentUser = this.userDataService.getUser();
    this.userForm = new FormGroup({
      name: new FormControl('', {
        validators: Validators.required,
      }),
      lastName: new FormControl('', {
        validators: Validators.required,
      }),
      email: new FormControl('', {
        validators: [Validators.required, Validators.email],
      }),
      phone: new FormControl('', {
        validators: Validators.required,
      }),
    });

    let primaryAddress:PartnerAddressDto  = this.currentUser.addresses.find((el)=>el.primary);

    this.userForm.controls.name.patchValue(this.currentUser.name);
    this.userForm.controls.lastName.patchValue(this.currentUser.lastName);
    this.userForm.controls.email.patchValue(this.currentUser.email);
    this.userForm.controls.phone.patchValue(primaryAddress.phone);

    this.readonlyState = {
      name: this.readonlyOnValid && this.userForm.controls.name.valid,
      lastName: this.readonlyOnValid && this.userForm.controls.lastName.valid,
      email: this.readonlyOnValid && this.userForm.controls.email.valid,
      phone: this.readonlyOnValid && this.userForm.controls.phone.valid
    }
  }

  public onTouched: () => void = () => {};

  writeValue(val: any): void {
    val && this.userForm.setValue(val, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.userForm.valueChanges
        .subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.userForm.disable() : this.userForm.enable();
  }

  validate(c: AbstractControl): ValidationErrors | null{
    return this.userForm.valid ? null : { invalidForm: {valid: false, message: "basicInfoForm fields are invalid"}};
  }

}
